module.exports = __webpack_public_path__ + "static/media/new-text-question-pink.bbad214d.svg";